const EmbeddedComponents = require('@/vue/EmbeddedComponents');
const PaymentMethodRef = require('@/lib/PaymentMethods/PaymentMethodRef');
const { PAYMENT_METHOD_CHANGED } = require('@/lib/Events/EventNames');

/**
 * @param $filter
 * @param {PaymentMethodService} paymentMethodService
 * @param $scope
 * @param {vuexService} vuexService
 */
function PayyoPaymentCtrl(
    $filter,
    paymentMethodService,
    $scope,
    vuexService
) {
    const thisPaymentMethodRef = PaymentMethodRef.CARD_PAYYO_CHIP_AND_PIN;
    $scope.$on('$destroy', () => {
        window.rootVueStore.commit('removeActiveEmbeddedComponent', EmbeddedComponents.PAYYO_PAYMENT_METHOD_COMPONENT);
    });
    $scope.$on(PAYMENT_METHOD_CHANGED, function (event, newPaymentMethod) {
        const newPaymentMethodRef = newPaymentMethod?.ref;
        if (newPaymentMethodRef === thisPaymentMethodRef) {
            window.rootVueStore.commit('addActiveEmbeddedComponent', { name: EmbeddedComponents.PAYYO_PAYMENT_METHOD_COMPONENT });
        } else {
            window.rootVueStore.commit('removeActiveEmbeddedComponent', EmbeddedComponents.PAYYO_PAYMENT_METHOD_COMPONENT);
        }
    });
    $scope.$on(
        'payment-modal.void-or-refund-payment-pressed',
        /**
         * @param event
         * @param {Payment} existingPayment
         *
         * @return {Promise<void>}
         */
        async function (event, existingPayment) {
            // This listener will be called if the void/refund button is pressed on any payment.
            // Check if it was pressed on a Payyo payment. If it was we deal with that here, otherwise ignore
            // it for it is to be dealt with by another listener.
            if (existingPayment?.paymentMethod?.ref === PaymentMethodRef.CARD_PAYYO_CHIP_AND_PIN) {
                $scope.$parent.setVoidOrRefundInProgress(existingPayment.thirdPartyID);
                vuexService.getStore().commit('payment/setRequestRefundOfPaymentInProgress', existingPayment.transactionRef);
                if ($scope.cart.getSelectedPaymentMethod().ref !== PaymentMethodRef.CARD_PAYYO_CHIP_AND_PIN) {
                    // We need to switch to the Payyo payment method as we aren't on it at the moment.
                    await $scope.$parent.selectPaymentMethod(paymentMethodService.getByRef(PaymentMethodRef.CARD_PAYYO_CHIP_AND_PIN));
                }
            }
        }
    );
}
module.exports = PayyoPaymentCtrl;
